export const sortTasks = (a,b) => {
    if (a.status === 'running' && b.status !== 'running') {
        return -1;
    }
    if (a.status !== 'running' && b.status === 'running') {
        return 1;
    }
    if (a.status === 'running' && b.status === 'running') {
        return a.task_id - b.task_id;
    }
    if (a.status === 'completed' && b.status !== 'completed') {
        return -1;
    }
    if (a.status !== 'completed' && b.status === 'completed') {
        return 1;
    }
    if (a.started_at < b.started_at) {
        return -1;
    }
    if (a.started_at > b.started_at) {
        return 1;
    }

    return a.started_at - b.started_at;
}